var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnlineTradingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114,
    height: 110.499,
    viewBox: "0 0 114 110.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "online_trading-icon",
    transform: "translate(-129.01 -58.289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shield--inject-14",
    transform: "translate(129.01 58.289)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 51.865,
    cy: 51.891,
    rx: 51.865,
    ry: 51.891,
    transform: "translate(3.731 3.541)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "3.012 3.012"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M96.763,343.59l3.748,6.5h-7.5Z",
    transform: "translate(-93.01 -294.486)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M246.118,107.848s-17.583-2.294-41.469-26.889V80.62l-.167.168-.163-.168v.339c-23.869,24.595-41.457,26.889-41.457,26.889-6.265,51.518,37.249,69.166,41.465,70.764v.12l.163-.06.167.06v-.12C208.874,177.014,252.387,159.344,246.118,107.848Z",
    transform: "translate(-147.975 -71.026)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M247.269,114.593s-16.2-2.109-38.215-24.779V89.5l-.155.159-.15-.159v.314c-22.019,22.683-38.215,24.779-38.215,24.779-5.779,47.505,34.35,63.791,38.215,65.256v.112l.15-.056.155.056v-.112C212.94,178.384,253.062,162.1,247.269,114.593Z",
    transform: "translate(-152.381 -76.091)",
    fill: "#e7ecef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M250.021,131.189s-12.881-1.663-30.327-19.654v-.245c-.039.039-.077.082-.12.12l-.12-.12v.245c-17.463,17.992-30.323,19.654-30.323,19.654-4.586,37.676,27.24,50.594,30.323,51.754v.09l.12-.047.12.047v-.09C222.781,181.783,254.6,168.865,250.021,131.189Z",
    transform: "translate(-163.059 -88.52)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M343.354,108.86l-.064.039",
    transform: "translate(-251.283 -87.134)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_35",
    "data-name": "Line 35",
    x2: 0.064,
    transform: "translate(92.007 21.764)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_37",
    "data-name": "Line 37",
    x1: 0.116,
    transform: "translate(82.402 21.764)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_48",
    "data-name": "Line 48",
    y2: 0.039,
    transform: "translate(92.072 21.726)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M392.227,216.338a.859.859,0,1,0-1.211.79l-.228,1.886h1.151l-.228-1.886A.859.859,0,0,0,392.227,216.338Z",
    transform: "translate(-278.227 -147.954)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M3.755,0l3.75,6.5H0Z",
    transform: "matrix(0.017, 1, -1, 0.017, 59.747, 0)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M96.763,350.09l3.748-6.5h-7.5Z",
    transform: "translate(10.47 -294.486)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-14",
    transform: "translate(150.467 82.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M231.473,199.225s-14.887,7.875-15.174,8.734S218.446,225,219.3,230.728a112.849,112.849,0,0,1,1,13.051v2.436h39.5s2.86-41.959,1.859-42.389-18.463-6.156-18.463-6.156Z",
    transform: "translate(-200.262 -161.997)",
    fill: "#3fb9eb",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M277.867,239.449s-1.584-.2-3.736-2.419V237h0v.03c-2.147,2.217-3.736,2.419-3.736,2.419a5.905,5.905,0,0,0,3.736,6.38h0A5.91,5.91,0,0,0,277.867,239.449Z",
    transform: "translate(-231.113 -184.431)",
    fill: "#3fb9ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M273.494,245.688a.266.266,0,0,1-.082,0,.429.429,0,0,1-.146-.047,6.311,6.311,0,0,1-3.959-6.813.429.429,0,0,1,.374-.374,7.09,7.09,0,0,0,3.435-2.251.451.451,0,0,1,.313-.211.4.4,0,0,1,.223.026.451.451,0,0,1,.219.189,6.958,6.958,0,0,0,3.435,2.225.429.429,0,0,1,.365.374,6.311,6.311,0,0,1-3.946,6.809.459.459,0,0,1-.232.073Zm-3.362-6.47a5.439,5.439,0,0,0,3.353,5.585,5.448,5.448,0,0,0,3.358-5.585,8.457,8.457,0,0,1-3.358-2.174A8.453,8.453,0,0,1,270.132,239.218Z",
    transform: "translate(-230.485 -183.852)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M253.833,221.2s-.283,13.928,0,21.089,1.146,17.326,1.146,17.326",
    transform: "translate(-221.622 -175.418)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 0.571,
    cy: 0.571,
    rx: 0.571,
    ry: 0.571,
    transform: "translate(32.928 50.258)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 0.571,
    cy: 0.571,
    rx: 0.571,
    ry: 0.571,
    transform: "translate(32.928 63.576)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M258.471,287.526a.575.575,0,1,1-.571-.576A.576.576,0,0,1,258.471,287.526Z",
    transform: "translate(-223.683 -212.922)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M264.738,295.339l-4.44,2.29s-5.582-3.579-7.441-3.725-4.152.146-5.44,1.289-2,2.006-3.435,2.006-3.147.142-2.289,1.289,3.864,1.147,5.011.717,2.86-.859,2.86-.859A4.655,4.655,0,0,0,252,300.064a13.567,13.567,0,0,0,3.147.43s2.722,1.718,4.44,1.572a10.267,10.267,0,0,0,3.006-.713l5.294-1.577S266.456,296.34,264.738,295.339Z",
    transform: "translate(-214.635 -216.869)",
    fill: "#ababab",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M260.362,290.7s-1.717-1.005-2.576,0-1.146,6.156-.717,6.728.717-.713,1.288-1.143S260.362,290.7,260.362,290.7Z",
    transform: "translate(-223.427 -214.804)",
    fill: "#ababab",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M265.244,291.573s-2.147-1.289-3.006-.571-2.435,6.444-2.005,7.015,1.718,0,1.863-.717a37.182,37.182,0,0,1,2.576-4.438Z",
    transform: "translate(-225.304 -215.109)",
    fill: "#ababab",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M270.276,294.93s-2.718-2.578-3.435-2.29-4.723,6.3-3.723,7.015,4.44-3.579,4.44-3.579l1.288,1",
    transform: "translate(-226.901 -216.155)",
    fill: "#ababab",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M276.493,300.1s-2.576-4.154-3.435-4.154-5.728,4.442-5.728,4.442,1.434,1.143,1.863.859,2.86-1.865,2.86-1.865.429,2.294,2.005,2.724",
    transform: "translate(-229.395 -218.056)",
    fill: "#ababab",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M304.687,211s3.289,0,3.577,1.435.571,4.58.571,4.58,12.6,29.5,12.169,30.789-19.61,7.591-20.181,7.591-5.153-7.3-5.153-7.3l9.3-5.873-4.865-13.051",
    transform: "translate(-245.567 -169.6)",
    fill: "#3fb9ea",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M306.435,232.29s-4.148,3.579-4.435,8.162",
    transform: "translate(-249.179 -181.744)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M301.289,232A16.228,16.228,0,0,0,299,239.857",
    transform: "translate(-247.467 -181.579)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M317.33,280.386s2.722-2.436,3.864-2.436,3.723.576,4.294,3.007",
    transform: "translate(-257.926 -207.789)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M321.67,275.241s3.864-2.294,5.153-1.289a7.616,7.616,0,0,1,2,2.719",
    transform: "translate(-260.403 -205.363)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M206.13,221.62l-4.294,27.494s-4.723,3.437-3.006,8.592c.678,2.036,2.576,3.007,11.31,2.148a92.031,92.031,0,0,0,0-15.607C209.423,235.1,206.13,221.62,206.13,221.62Z",
    transform: "translate(-190.093 -175.658)",
    fill: "#3fb8e9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M194.018,291.455s2.941.069,3.147.408.206,4.927-.477,5.409-1.164.683-1.438,0-.751-2.122-.751-2.122-1.846,2.053-3.628,1.641-1.984-1.229-2.529-1.435a12.308,12.308,0,0,1-2.533-.43,8.277,8.277,0,0,1-2.6-2.324s-3.285,2.874-3.967,2.53.069-1.435,1.164-2.6,1.846-2.328,2.941-2.6,5.47-.821,6.84-.408a8.036,8.036,0,0,1,2.666,1.229A5.584,5.584,0,0,0,194.018,291.455Z",
    transform: "translate(-178.982 -214.304)",
    fill: "#ababab",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M190.357,288.582s-1.846-.344-2.052.889.275,6.014.751,6.444a1.189,1.189,0,0,0,1.782-.619,36.4,36.4,0,0,0,.2-5.129S191.246,288.994,190.357,288.582Z",
    transform: "translate(-184.274 -213.828)",
    fill: "#ababab",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M196.18,289s-2.739-1.718-3.435-.752.069,6.775.429,7.531,1.64,1.027,1.915.2.339-4.24.429-4.446",
    transform: "translate(-186.674 -213.494)",
    fill: "#ababab",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M201.054,289.839c-.069.206,0,6.229-.82,6.642s-1.984.408-1.984-2.328.137-6.092.889-6.367,2.873.894,3.628,1.577",
    transform: "translate(-189.977 -213.375)",
    fill: "#ababab",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_55",
    "data-name": "Line 55",
    x1: 0.618,
    y1: 2.737,
    transform: "translate(14.907 78.109)",
    fill: "#ababab",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M242.93,201.18v7.806l3.959-2.831Z",
    transform: "translate(-215.472 -163.999)",
    fill: "#29a3d5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M247.679,205.413l-4.749-8.6,4.637-3.286Z",
    transform: "translate(-215.472 -159.635)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M250.56,179.894s.906,7.806,1.134,10.07.339,3.738.339,3.738,7.012-8.162,8.369-9.962,1.7-2.376,1.7-2.376l.343-8.373Z",
    transform: "translate(-219.826 -147.919)",
    fill: "#c9d6dc",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M250.749,181.53a5.24,5.24,0,0,0,4.839.8c3.006-1.1,3.864-3.007,4.521-3.665.429-.43,1.331-1.022,2.168-1.718l.163-3.957-11.881,6.9S250.637,180.547,250.749,181.53Z",
    transform: "translate(-219.826 -147.919)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M257.159,204.34l-3.169,7.239,5.543-3.622Z",
    transform: "translate(-221.783 -165.801)",
    fill: "#29a3d5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M261.37,194.272l2.6,7.015,7.694-9.958-2.263-4.64Z",
    transform: "translate(-225.994 -155.734)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M236.342,116.887a12.029,12.029,0,0,0-4.513,6.693c-1.043,4.378,1.164,9.133,1.327,10.6s-.464,3.368.228,5.177,3.748,4.674,4.238,6.014,3.229,3.755,6.209,2.664,3.916-3.007,4.594-3.669,2.576-1.77,3.5-3.007,1.5-2.122,1.5-2.122a39.376,39.376,0,0,0,2.619-11.221c.206-5.288-2.928-11.286-8.849-12.935A13.9,13.9,0,0,0,236.342,116.887Z",
    transform: "translate(-208.979 -114.632)",
    fill: "#ededed",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M231.282,150.791s.082,3.488,1.348,4.4,4,.859,5.1.4,1.743-2.788,2.207-3.458,1.971-.314,1.971-.314,1.078,3.05,1.932,3.4,3.555.945,5.445-.043,2.259-4.816,2.259-4.816,1.1-.21.794-.778-8.686-.558-9.678-.232-1.121.773-1.662.765-1.288-.576-1.829-.584-8.059.125-8.059.125Z",
    transform: "translate(-208.728 -134.308)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M248.165,115.144a13.959,13.959,0,0,0-10.846,1.779,12.23,12.23,0,0,0-4.079,5.318c.236-.558,1.207-2.621,3.006-3.08,2.091-.537,2.121,1.375,4.762.73s6.746-2.728,8.558-1.693,3.246,3.192,2.508,5.434-.812,3.927-.069,4.5a6.171,6.171,0,0,1,1.718,3.51c.056.928,1.288,1.559,2.6,1.392a28.207,28.207,0,0,0,.7-4.953C257.212,122.8,254.073,116.794,248.165,115.144Z",
    transform: "translate(-209.943 -114.668)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M247.3,165.78s-.7,1.005-.06,1.465a.927.927,0,0,0,1.194.125",
    transform: "translate(-217.781 -143.807)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M249.42,168.092a3.435,3.435,0,0,0,1.718.808,2.979,2.979,0,0,0,1.992-.859",
    transform: "translate(-219.176 -145.096)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M257.24,166.639s.309.455,1.2-.095c0,0,1.211-.326.5-1.684",
    transform: "translate(-223.638 -143.282)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M247.89,173.9a7.444,7.444,0,0,0,6.23-.6",
    transform: "translate(-218.303 -148.096)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M265.011,155.288c-.021.589-.309,1.065-.64,1.061s-.58-.49-.554-1.078.309-1.065.64-1.061S265.037,154.7,265.011,155.288Z",
    transform: "translate(-227.39 -137.207)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M245.231,155.434c0,.593-.309,1.065-.64,1.061s-.58-.485-.554-1.074.309-1.065.64-1.061S245.257,154.845,245.231,155.434Z",
    transform: "translate(-216.103 -137.293)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M231.282,150.791s.082,3.488,1.348,4.4,4,.859,5.1.4,1.743-2.788,2.207-3.458,1.971-.314,1.971-.314,1.078,3.05,1.932,3.4,3.555.945,5.445-.043,2.259-4.816,2.259-4.816,1.1-.21.794-.778-8.686-.558-9.678-.232-1.121.773-1.662.765-1.288-.576-1.829-.584-8.059.125-8.059.125Z",
    transform: "translate(-208.728 -134.308)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M279.494,150.21l3.525,1.731-.24.558-4.079-1.512Z",
    transform: "translate(-235.883 -134.926)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M242.65,149.372c-.992.322-1.121.773-1.662.765s-1.288-.576-1.829-.584-8.059.125-8.059.125l.1.67,7.879-.12s1.151-.094,1,.8c-.215,1.246-.155,1.126-.155,1.126.459-.67,1.971-.314,1.971-.314l.107.288c-.073-.567-.133-1.452.167-1.748.455-.43,2.516-.305,4.371-.4a32.471,32.471,0,0,1,4.989.4l.756-.816C251.62,149.037,243.621,149.054,242.65,149.372Z",
    transform: "translate(-208.722 -134.32)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M281,155.29s2.645-3.57,3.92-2.767.258,4.507-.571,6.186-2.8,2.1-3.186.747",
    transform: "translate(-237.196 -136.178)",
    fill: "#c9d6dc",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-14",
    transform: "translate(139.229 143.492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M193.187,279.677h-33.2L155.81,256.62h33.2Z",
    transform: "translate(-154.522 -256.62)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M190.187,279.677h-33.2L152.81,256.62h33.2Z",
    transform: "translate(-152.81 -256.62)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M165.53,287.742h31.916l-3.074-16.982Z",
    transform: "translate(-160.068 -264.685)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_108",
    "data-name": "Rectangle 108",
    width: 52.204,
    height: 1.396,
    transform: "translate(4.174 23.057)",
    fill: "#3fb9ea",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_109",
    "data-name": "Rectangle 109",
    width: 18.553,
    height: 1.396,
    transform: "translate(37.824 23.057)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineTradingIcon);
export default __webpack_public_path__ + "static/media/online_trading-icon.e571fc9134ba7e4a0e49455253813502.svg";
export { ForwardRef as ReactComponent };